import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { default as Dropdown } from '../../../../components/Dropdown/Dropdown';
var transparentColorStyle = {
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  borderBottomColor: 'transparent'
};
var dropdownStyles = {
  container: function container(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({}, !p.open && {
      ':hover': _defineProperty({
        backgroundColor: v.backgroundColorHover,
        borderColor: v.borderColorHover
      }, "& .".concat(Dropdown.slotClassNames.triggerButton), {
        color: v.triggerButtonColorHover
      })
    });
  },
  triggerButton: function triggerButton(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return {
      ':hover': Object.assign({}, transparentColorStyle, {
        color: v.triggerButtonColorHover
      }),
      ':focus': {
        color: v.color,
        ':active': {
          color: v.color
        }
      }
    };
  }
};
export default dropdownStyles;